import { render, staticRenderFns } from "./pending-leads.vue?vue&type=template&id=2473baa0"
import script from "./pending-leads.vue?vue&type=script&lang=js"
export * from "./pending-leads.vue?vue&type=script&lang=js"
import style0 from "./pending-leads.vue?vue&type=style&index=0&id=2473baa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports